import React from 'react';
import { Link } from 'react-router-dom';
import '../style/ServicesMenuStyles.css';
import { serviceData } from '../data/serviceData';

const ServicesMenu = () => {
  

  return (
    <div className="services-menu-container">
      <h2></h2>
      <div className="services-grid">
        {serviceData.map((service, index) => (
          <div key={index} className="service-category">
            <h3>{service.category}</h3>
            <ul>
              {service.items.map((item, itemIndex) => (
                <li key={itemIndex}>
                  <span className="service-name">{item.name}</span>
                  <span className="service-price">{item.price}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <a href="/booking" rel="noopener noreferrer" className="view-all-button">
         Book Now
      </a>
    </div>
  );
};

export default ServicesMenu;
